module.exports = __webpack_public_path__ + "assets/attentionIcon.576a2e14.svg";